<template>
  <div class="my-vue-goodshare">
    <vue-goodshare-facebook has_icon has_counter title_social="Facebook"/>
    <vue-goodshare-twitter has_icon title_social="Twitter"/>
    <!-- <vue-goodshare-linked-in has_icon has_counter title_social="LinkedIn"/>
    <vue-goodshare-pinterest has_icon has_counter title_social="Pinterest"/> -->
    <vue-goodshare-line has_icon title_social="LINE"/>
  </div>
</template>

<script>
// Import VueGoodshare social network components
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VueGoodshareTumblr from "vue-goodshare/src/providers/Tumblr.vue";
import VueGoodsharePinterest from "vue-goodshare/src/providers/Pinterest.vue";
import VueGoodshareLine from "vue-goodshare/src/providers/Line.vue";

export default {
  name: "MyVueGoodshare",
  components: {
    VueGoodshareFacebook,
    VueGoodshareLinkedIn,
    VueGoodsharePinterest,
    VueGoodshareTwitter,
    VueGoodshareLine,
  }
};
</script>

<style>
.my-vue-goodshare {
  font-size: 90%;
  color: white;
}
</style>